module.exports = __webpack_public_path__ + "global-outlook.jpg?7ee0a743e964b28cfca1b6a39671fa47";